import { create } from "zustand";
import { createCommonStore, CommonStore } from "./commonStore";
import { createMemberStore, MemberStore } from "./memberStore";
import { createUserStore, UserStore } from "./userStore";
import { createActivityStore, ActivityStore } from "./activityStore";
import { createTenantStore, TenantStore } from "./tenantStore";
import { createParticipantStore, ParticipantStore } from "./participantStore";
import { createDocumentStore, DocumentStore } from "./documentStore";
import { createStatisticStore, StatisticStore } from "./statisticStore";
import { createNotificationEmailStore, NotificationEmailStore } from "./notificationEmailStore";
import { createEmailLogStore, EmailLogStore } from "./emailLogStore";
import { createEmailTemplateStore, EmailTemplateStore } from "./emailTemplateStore";
import { createPaymentStore, PaymentStore } from "./paymentStore";
import { createModalStore, ModalStore } from "./modalStore";
import React from "react";
import { createFamilyMemberStore, FamilyMemberStore } from "./familyMemberStore";

type UIState = {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
};

type AppStore = {
  memberStore: MemberStore;
  commonStore: CommonStore;
  userStore: UserStore;
  paymentStore: PaymentStore;
  familyMemberStore: FamilyMemberStore;
  activityStore: ActivityStore;
  tenantStore: TenantStore;
  participantStore: ParticipantStore;
  documentStore: DocumentStore;
  statisticStore: StatisticStore;
  notificationEmailStore: NotificationEmailStore;
  emailLogStore: EmailLogStore;
  emailTemplateStore: EmailTemplateStore;
  uiStore: UIState;
  modalStore: ModalStore;
};

export const useStore = create<AppStore>((set, get) => ({
  memberStore: createMemberStore(set, get),
  commonStore: createCommonStore(set, get),
  userStore: createUserStore(set, get),
  paymentStore: createPaymentStore(set, get),
  familyMemberStore: createFamilyMemberStore(set, get),
  activityStore: createActivityStore(set, get),
  tenantStore: createTenantStore(set, get),
  participantStore: createParticipantStore(set, get),
  documentStore: createDocumentStore(set, get),
  statisticStore: createStatisticStore(set, get),
  notificationEmailStore: createNotificationEmailStore(set, get),
  emailLogStore: createEmailLogStore(set, get),
  emailTemplateStore: createEmailTemplateStore(set, get),
  uiStore: {
    sidebarOpen: true,
    setSidebarOpen: (open: boolean) =>
      set((state) => ({ uiStore: { ...state.uiStore, sidebarOpen: open } })),
    toggleSidebar: () =>
      set((state) => ({
        uiStore: { ...state.uiStore, sidebarOpen: !state.uiStore.sidebarOpen },
      })),
  },
  modalStore: createModalStore(set, get),
}));